import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=c950fd56&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=c950fd56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c950fd56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c950fd56')) {
      api.createRecord('c950fd56', component.options)
    } else {
      api.reload('c950fd56', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=c950fd56&scoped=true&", function () {
      api.rerender('c950fd56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xGD5lfQhFdZh/JS/comp/PopupBox.vue"
export default component.exports